import api from './api';

export interface DiagnosisType {
  id: number;
  name: string;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface DiagnosisTypeCreate {
  name: string;
}

export interface DiagnosisTypeUpdate {
  name?: string;
}

const diagnosisTypeService = {
  getAll: async (tenantId: number): Promise<DiagnosisType[]> => {
    const response = await api.get('/diagnosis-types/', { params: { tenant_id: tenantId } });
    return response.data;
  },
  create: async (tenantId: number, data: DiagnosisTypeCreate): Promise<DiagnosisType> => {
    const response = await api.post(`/diagnosis-types/?tenant_id=${tenantId}`, data);
    return response.data;
  },
  update: async (id: number, data: DiagnosisTypeUpdate): Promise<DiagnosisType> => {
    const response = await api.put(`/diagnosis-types/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/diagnosis-types/${id}`);
  },
};

export default diagnosisTypeService;
